/**
 * Base URL de l'API en production / app mobile (Capacitor).
 * En dev local : vide → fetch('/api/...') passe par le proxy CRA (package.json).
 */
export function getApiBase() {
  const base = (process.env.REACT_APP_API_URL || '').trim();
  return base.replace(/\/$/, '');
}

export function resolveApiUrl(path) {
  if (typeof path !== 'string') return path;
  if (!path.startsWith('/api')) return path;
  const base = getApiBase();
  if (!base) return path;
  return `${base}${path}`;
}

/** Préfixe les appels /api pour l'app Android (Capacitor). */
export function installApiFetchPatch() {
  if (typeof window === 'undefined' || window.__gestionCAISApiFetchPatched) return;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === 'string') {
      return nativeFetch(resolveApiUrl(input), init);
    }
    if (input instanceof Request && input.url) {
      const resolved = resolveApiUrl(input.url);
      if (resolved !== input.url) {
        return nativeFetch(new Request(resolved, input), init);
      }
    }
    return nativeFetch(input, init);
  };
  window.__gestionCAISApiFetchPatched = true;
}
